<template>
  <div class="wrapper">
    <navigation adaption/>
    <template v-if="showNotBannedPage">
      <not-banned-page
        :result="result"
        @onCall="openPhoneDialog"
        @onReWithdraw="confirm"
      />
    </template>
    <template v-else>
      <pulldown-page class="page withdraw-result" background="white" :refresh="pulldown" color="#333333" >
        <p slot="pulling" class="refresh">下拉可刷新</p>
        <p slot="loosing" class="refresh">释放可刷新</p>

        <div class="result-show">
          <div v-if="isKingCard && statusMapping === '4'" class="king-wait">
            <div class="badge">
              插队申请中
            </div>
          </div>
          <div class="animation-wapper" v-else-if="showGif">
            <lottie ref="animataion" :options="showGif"  v-on:animCreated="handleAnimation"/>
          </div>
          <h1>{{ resultStatus[statusMapping] && resultStatus[statusMapping].text }}</h1>
          <!-- 放款成功 -->
          <template v-if="statusMapping === '0'">
            <h2 class="description">已为您放款，具体以银行实际到账时间为准。</h2>
          </template>

          <!-- 放款中 -->
          <template v-if="statusMapping === '1'">
            <h2 class="loans">
              我们正在为您放款,预计两天内到账
            </h2>
            <h2 class="loans">
              为不影响放款进度,请留意接听我们的服务监督电话
            </h2>
          </template>

          <!-- 放款失败 -->
          <template v-if="statusMapping === '2'">
            <h2 class="description">
              <!-- 抱歉，由于系统异常导致放款失败， -->
              {{ result.rejectReason }}
              <br/>
            <!-- 您可重新发起提现申请；如有疑问联系客服。 -->
            </h2>
          </template>
          <div v-if="statusMapping === '2'" class="servicePhone" @click="openPhoneDialog">
            <img src="../../assets/images/call.png"/>
            <span>联系客服</span>
          </div>
          <!-- 信用不足 -->
          <template v-if="statusMapping === '3'">
            <div v-if="!isOverdue">
              <img src="./image/img_tishi.png" alt="提示" class="tips">
            </div>
            <div class="overdue" v-else>
              <img src="./image/icon_tanhao.png" alt="">
              <div>
                <span class="left">您有逾期账单，</span>
                <span class="middle" @click="goRepayment">归还逾期账单 </span>
                <span>恢复信用值</span>
              </div>
            </div>
            <h2 class="description">{{ lockingDay | date }} 可重新提现</h2>
          </template>

          <!--提现审核中-->
          <template v-if="statusMapping === '4'">
            <h2 class="description">
              {{isKingCard ? '尊敬的会员，已为您启用VIP专属审核通道': '我们正在加急为您审核，请您耐心等待'}}
            </h2>
          </template>

          <!-- 放款成功时显示 -->
          <div class="loan-info section-container" v-if="statusMapping === '0'">
            <div class="info-item">
              <p class="item-title">借款金额</p>
              <p class="item-content">{{ result.applyAmount | currency }}</p>
            </div>

            <div class="info-item">
              <p class="item-title">借款期限</p>
              <p class="item-content">{{ result.dueTime }}个月</p>
            </div>

            <div class="info-item">
              <p class="item-title">借款日期</p>
              <p class="item-content">{{ result.loanDate | date }}</p>
            </div>

            <div class="info-item">
              <p class="item-title">借据号</p>
              <p class="item-content">{{ result.platBillNo }}</p>
            </div>
          </div>

          
          <div class="api-banner" v-if="statusMapping === '0'">
            <!-- api 老用户 用户引导关注的 banner -->
            <guideApiFollow placeEnum="LOAN_SUCCESS"></guideApiFollow>
          </div>
        </div>

        <nd-button class="btn loan-btn" v-if="statusMapping === '2'" @click="goWithdraw" v-stat="{ id: 10141 }">立即提现</nd-button>
        <!-- <nd-button class="btn loan-btn" v-if="statusMapping === '3' && isOverdue" @click="goRepayment">立即还款积累信用</nd-button> -->
        <!-- 确认按钮 -->
        <nd-button
          class="btn confirm-btn line"
          v-showApiBackHome
          :class="[
            { 'btn-gutter': statusMapping === '2' || statusMapping === '3' },
            { 'btn-low-gutter': statusMapping === '1' }
          ]"
          @click="confirm"
        >
          {{ resultStatus[statusMapping] && resultStatus[statusMapping].btn }}
        </nd-button>

        <div class="flex" style="height: 90px;"></div>
      </pulldown-page>
    </template>
    <service-jw v-model="customerShow" />
    <download-dialog ref="downloadDialog"></download-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { getKey, judgeClientSystem, mockHrefJump } from '../../assets/utils'
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import Lottie from 'vue-lottie'
import { fail, wait, success } from '@/assets/json/index'
// 常量定义
const RESULT_STATUS = {
  // 已放款
  '0': {
    text: '已为您放款成功！',
    class: 'success',
    btn: '返回首页'
    // description: '已为您放款，具体以银行实际到账时间为准。'
  },
  // 放款中
  '1': {
    text: '提现成功，放款中',
    class: 'wait',
    btn: '返回首页'
    // description: '我们正在为您放款，请耐心等待。等待过程中，您 可下拉刷新结果；或联系客服010-123456'
  },
  // 放款失败
  '2': {
    text: '放款失败',
    class: 'fail',
    btn: '返回首页'
    // description: '抱歉，由于系统异常导致放款失败，您可重新发起 提现申请；如有疑问联系客服XXXXX'
  },
  '3': {
    text: '信用值不足，审核失败',
    class: 'not-enough',
    btn: '返回首页'
    // description: '抱歉，由于系统异常导致放款失败，您可重新发起 提现申请；如有疑问联系客服XXXXX'
  },
  '4': {
    text: '提现审核中',
    class: 'withdraw-wait',
    btn: '返回首页'
  }
}

export default {
  name: 'withdraw-result',

  description: '提现结果',

  customReadyNotify: true,

  components: {
    'lottie': Lottie,
    'notBannedPage': () => import('./components/notbanned-page.vue'),
    serviceJw: () => import('@/components/service-jw'),
    downloadDialog: () => import('@/components/download-dialog'),
    guideApiFollow: () => import('@/components/guide-api-follow/index.vue')
  },

  data () {
    return {
      showVip: false, // 底部小美vip广告位显示
      resultStatus: RESULT_STATUS,
      animationSpeed: 1,
      showGif: null,
      result: {
        applyAmt: '', // 申请金额
        applyTerm: '', // 申请期限
        approvedDate: '', // 审核日期
        createTime: '', // 提现日期
        originApprovedDate: '', // 授信通过时间
        loanDesc: '', // 结果描述
        loanStatusVoEnum: '', // 放款状态
        riskStatus: '', // 风控状态
        lockingDay: '', // 锁定日期
        tel: '',
        rejectReason: '',
        failedReason: '', // 放款失败后端返回的文案，
        platBillNo: '', // 借据号
        rejectNotBannedMark: '', // 是否标记为不封禁
        rejectAgainProbability: '' // 跑赢比例
      },
      isLoading: false,
      clipboard: null,
      customerShow: false,
      isKingCard: false,
      polling: null // 审核中轮询
    }
  },

  computed: {
    // 放款结果映射
    statusMapping () {
      if (this.type) return this.type
      if (this.result.loanStatusVoEnum === 'LOANING') return '1' // 放款中
      if (this.result.loanStatusVoEnum === 'LOAN_PASSED') return '0' // 已放款
      if (this.result.loanStatusVoEnum === 'LOAN_FAILURE') return '2' // 放款失败
      if (this.result.loanStatusVoEnum === 'WITHDRAWALS_REJECTED') return '3' // 信用不足
      if (['LOAN_AUDIT', 'LOAN_WAIT_VIP'].includes(this.result.loanStatusVoEnum)) return '4' // 提现审核中
      return '1'
    },
    ...mapState('withdraw', ['customerServicePhone']),

    ...mapState('activities', {
      qualificationCoupon: state => state.qualificationCoupon ? (state.qualificationCoupon[0] || {}) : {}
    }),

    ...mapState('user', {
      creditStatus: state => state.quotaInfo.creditStatus,
      lockingDay: (state) => state.quotaInfo.lockingDay
    }),

    isOverdue () {
      // 当期逾期
      if (this.result.rejectReason === 'C') {
        return true
      } else {
        return false
      }
    },
    showNotBannedPage () {
      return this.result.loanStatusVoEnum === 'WITHDRAWALS_REJECTED' && this.result.rejectNotBannedMark === 'Y'
    }
  },
  beforeRouteLeave (to, from, next) {
    clearInterval(this.polling)
    next((vm) => {})
  },
  async created () {
    this.type = this.$route.query.type || ''
    if (this.$route.query.loanApplyNo === 'false') {
      this.$bus.$emit('ready')
    } else {
      try {
        await Promise.all([
          this.queryVipShow(),
          this.getLoanResult(),
          this.getLimitX({ loanPlatform: 'TMD' })
        ])
        this.$bus.$emit('ready')
        await this.getMemberShipStatusX()
      } catch (exp) {
        console.log(exp)
        this.$bus.$emit('error')
      }
    }
  },

  methods: {
    ...mapActions('withdraw', [
      'getLoanResultX'
    ]),

    ...mapActions('user', ['getLimitX', 'showStatusX', 'getBizTag']),
    ...mapActions('vip', ['getMemberShipStatus']),
    // 查询vip展示状态
    async queryVipShow () {
      const { success, data } = await this.showStatusX({
        rightsType: 'XM_VIP'
      })
      if (success) {
        this.showVip = data
      }
    },
    // 跳转权益卡vip界面
    jumpVip () {
      this.$router.push('/vip/index')
    },
    handleAnimation (anim) {
      console.log('handleAnimation')
      this.anim = anim
    },
    // 下拉刷新
    pulldown () {
      window.location.reload()
    },
    // 处理接口对应的gif值
    changeGif (title) {
      let value = ''
      if (this.type) value = this.type
      else if (title === 'LOANING') value = '1' // 放款中
      else if (title === 'LOAN_PASSED') value = '0' // 已放款
      else if (title === 'LOAN_FAILURE') value = '2' // 放款失败
      else if (title === 'WITHDRAWALS_REJECTED') value = '3' // 信用不足
      else if (title === 'LOAN_AUDIT') value = '4' // 提现审核中
      else value = '1'
      this.dealGif(value)
    },
    // 判断gif展示哪张图片
    dealGif (value) {
      let arr = {}
      if (value === '0') {
        arr = { animationData: success, loop: false }
      } else if (value === '1' || value === '4') {
        arr = { animationData: wait }
      } else {
        arr = { animationData: fail, loop: false }
      }
      this.showGif = arr
    },
    confirm () {
      // 额度有效跳转到提现页
      if (this.statusMapping === '3' && ['CREDIT_SUCCESS', 'LOAN_INFO'].includes(this.creditStatus)) {
        this.goWithdraw()
      } else {
        this.backHome()
      }
    },

    // 拨打电话
    callService () {
      this.$report({
        id: 10061,
        args: {
          position: 'page_reconciliation',
          target: this.customerServicePhone
        }
      })
      mockHrefJump(`tel:4000100008`)
    },

    closeDialog () {
      this.$report({
        id: 10062,
        args: {
          postion: 'page_reconciliation'
        }
      })
    },

    async refresh () {
      if (this.$route.query.loanApplyNo === 'false') {
        setTimeout(() => {
          this.isLoading = false
        })
        return false
      }
      await this.getLoanResult()
      await this.getLimitX({ loanPlatform: 'TMD' })

      this.isLoading = false
      return true
    },

    async getLoanResult () {
      const response = await this.getLoanResultX({ loanApplyNo: this.$route.query.loanApplyNo })
      if (response.success) {
        this.result = response.data || {}

        // 针对isApiH5成功失败跳转不同第三方页面
        const API_RETURN_URLS = getKey('API_RETURN_URLS') || {}

        if (response.data.rejectGuideReApply === 'Y') {
          this.$router.replace('/withdraw/preview-next')
          return
        }
        
        if (this.isApiH5 && API_RETURN_URLS.successUrl) {
          if (['LOAN_PASSED'].includes(this.result.loanStatusVoEnum) && API_RETURN_URLS.successUrl) {
            window.location.href = API_RETURN_URLS.successUrl
            return 
          }
        }

        if (this.isApiH5 && API_RETURN_URLS.failUrl) {
          if (['WITHDRAWALS_REJECTED', 'LOAN_FAILURE', 'APPLY_FAIL', 'TIMEOUT', 'LOAN_GIVE_UP'].includes(this.result.loanStatusVoEnum) && API_RETURN_URLS.failUrl) {
            window.location.href = API_RETURN_URLS.failUrl
            return 
          }
        }
      
        // 业务提额流程
        if (this.isNotEmptyString(this.result.bizAdjustAmountLoanSerialNo)) {
          this.$router.replace({
            path: '/withdraw/biz-limit-up-confirm',
            query: {
              loanSerialNo: this.result.bizAdjustAmountLoanSerialNo
            }
          })
          return
        }
       
        if (this.isNotEmptyString(this.result.upCardProcess)) {
          clearInterval(this.polling)
          this.$router.replace(`/withdraw/result5?loanApplyNo=${this.$route.query.loanApplyNo}`)
          return
        }
        if (['LOAN_FAILURE', 'APPLY_FAIL'].includes(this.result.loanStatusVoEnum) && this.result.passCardProcess === 'Y') {
          clearInterval(this.polling)
          // pass卡放款失败，跳转到pass卡放款失败页面
          this.$router.replace(`/withdraw/refused/pass?loanApplyNo=${this.$route.query.loanApplyNo}`)
          return
        }
        this.changeGif(this.result.loanStatusVoEnum)
        if (['LOANING', 'LOAN_AUDIT', 'LOAN_WAIT_UP', 'LOAN_WAIT_VIP'].includes(this.result.loanStatusVoEnum)) {
          if (!this.polling) {
            this.polling = setInterval(async () => {
              await this.getLoanResult()
            }, 10000)
          }
        } else {
          this.getLimitX({ loanPlatform: 'TMD' })
          setTimeout(() => {
            this.$refs.downloadDialog.init('WITHDRAW_RESULT')
          }, 1000)
          clearInterval(this.polling)
          if (this.result.loanStatusVoEnum === 'WITHDRAWALS_REJECTED') {
            // 是pass卡，跳转pass卡拒绝页面
            await this.checkIsPasscard()
          }
        }
      } else {
        throw new Error(response.msg)
      }
    },
    async checkIsPasscard () {
      const [bizTagRes, showStatusRes] = await Promise.all([
        this.getBizTag(),
        this.showStatusX({
          rightsType: 'PASS'
        })
      ])
      if (bizTagRes.success && showStatusRes.success) {
        const isPasscard = bizTagRes.data.passCardTag === 'HAVE_QUALIFICATION' && showStatusRes.data
        if (isPasscard) {
          this.$router.replace({
            path: '/withdraw/result3'
          })
        }
        return isPasscard
      }
      return false
    },
    // goHome () {
    //  if (hasNativeMethod('exit') && judgeClientSystem() !== 'IOS') {
    //     jsBridge('exit')
    //   } else {
    //     jsBridge('navigateTo', { path: 'home', exitCurrent: true })
    //     if (getKey('channel') === 'API-XHQB') {
    //       window.location.href = getKey('successUrl')
    //     } else {
    //       this.$router.push('/')
    //     }
    //   }
    // },

    goWithdraw () {
      if (hasNativeMethod('navigateTo') && (judgeClientSystem() !== 'IOS' || (judgeClientSystem() === 'IOS' && getKey('appChannel') === 'official-iOS'))) {
        jsBridge('navigateTo', { path: 'withdraw', exitCurrent: true })
      } else {
        this.$router.replace('/middle/limit')
      }
    },
    goRepayment () {
      if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
        jsBridge('navigateTo', { path: 'repayment', exitCurrent: true })
      } else {
        this.$router.push({
          path: '/repayment',
          query: { type: 'TMD' }
        })
      }
    },

    // 打开客服电话
    openPhoneDialog () {
      this.customerShow = true
    },

    // 关闭客服电话
    closePhoneDialog () {
      this.customerShow = false
    },
    async getMemberShipStatusX () {
      const { success, data } = await this.getMemberShipStatus({
        memberTypes: ['KING']
      })
      if (success && data) {
        this.isKingCard = data.haveMember === 'Y'
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

    .api-banner {
      margin:20px 30px
    }
    .loans{
        font-size: 30px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        font-weight: 400;
        margin-top:8px !important;
    }
    .wrapper {
        height: 100%;
    }
    .withdraw-result {
        position: relative;
        min-height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        overflow: auto;

        .refresh{
            color: #fff;
        }

        .navigation-refresh {
            position: absolute;
            top: 30px;
            right: 0;
            left: 0;
        }

        .btn {
            width: 320px;
            height: 80px;
            line-height: 80px;
            margin: 0 auto;
            font-size: 32px;
            margin-top: 80px;

            & + .btn {
                margin-top: 30px;
            }
        }

        .section-container {
            width: 690px;
            margin: 0 auto;
            margin-top: 63px;
            background: rgba(250,250,250,1);
            border-radius: 20px;

            &.no-container {
                background-color: transparent;
                border-radius: 0;
                width: unset;
                height: unset;
                margin-top: 70px;
            }
        }

        .loan-info {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            padding: 45px 40px;

            .info-item {
                flex: 1;
                display: flex;
                flex-direction: row;
                text-align: center;
                .item-title {
                    width: 160px;
                    font-weight: 400;
                }
                .item-content {
                    flex: 1;
                    font-weight: 500;
                    font-family:DIN-Medium,DIN;
                    word-break: break-all;
                }
                p {
                    font-family: 'PingFangSC-Medium';
                    font-size: 28px;
                    text-align: left;
                }
            }
        }

        .loan-step {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;

            .step {
                text-align: center;
                overflow: hidden;
                flex: 1;

                .custom-icon {
                    display: block;
                    background-size: 100% 100%;
                    margin: 0 auto;

                    &.step-status {
                        width: 52px;
                        height: 52px;
                        /*background-image: url(../../assets/img/withdraw-result/procedure_icon02.png);*/
                        position: relative;

                        // &.compelete {
                            /*background-image: url(../../assets/img/withdraw-result/procedure_icon01.png);*/
                        // }

                        &::before, &::after {
                            content: "";
                            display: block;
                            position: absolute;
                            height: 2px;
                            top: 50%;
                            margin-top: 1px;
                            background-color: #FFF;
                        }

                        &::before {
                            left: -100px;
                            right: 60px;
                        }

                        &::after {
                            left: 60px;
                            right: -100px;
                        }

                        &:last-child {
                            &::after {
                                width: 0;
                            }
                        }
                    }
                }

                &:first-child {
                    .custom-icon {
                        &.step-status {
                            &::before {
                                width: 0;
                            }
                        }
                    }
                }

                &:last-child {
                    .custom-icon {
                        &.step-status {
                            &::after {
                                width: 0;
                            }
                        }
                    }
                }

                p {
                    font-size: 30px;
                    font-family: 'PingFangSC-Medium';
                    font-weight: 500;

                    &.date {
                        font-size: 22px;
                        font-family: 'PingFangSC-Regular';
                        font-weight: 400;
                    }
                }
            }

            .qrcode {
                height: 377px;
                width: 377px;
            }
        }

        .result-show {
            padding-top: 220px;
            flex-grow: 1;

            .king-wait {
              width: 162px;
              height: 174px;
              margin: 0 auto;
              background: url(./image/img_wait_clean_king.png) no-repeat;
              background-size: 100%;
              margin-bottom: 20px;
              .badge {
                width: 150px;
                height: 46px;
                background: #FFE2BD;
                border-radius: 20px 100px 100px 0px;
                font-size: 24px;
                font-weight: 400;
                color: #763E12;
                line-height: 46px;
                text-align: center;
                position: absolute;
                top: 209px;
                left: 444px;
              }
            }

            .animation-wapper {
                height: 210px;
                width: 210px;
                margin: 0 auto;
            }

            .description {
                margin: 0;
                width: 100%;
                padding: 0 63px;
                color: rgba(102,102,102,1);
                margin-top: 15px;
                font-size: 26px;
                text-align: center;
                span {
                    color: @theme;
                }
            }
            .tips {
                width: 600px;
                height: 91px;
                margin-left: 75px;
                margin-top: 19px;
            }
            .overdue {
                margin: 0 auto;
                margin-top: 19px;
                width: 530px;
                height: 90px;
                background: #F7F7F7;
                border-radius: 20px;
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FF4633;
                line-height: 33px;
                text-align: center;
                display: flex;
                flex-direction: row;
                align-items: center;
                img {
                    margin-left: 15px;
                    width: 32px;
                    height: 32px;
                }
                div {
                    margin-left: 15px;
                    .middle {
                        text-decoration: underline;
                    }
                }
            }
            .custom-icon {
                display: block;
                width: 174px;
                height: 174px;
                margin-left: 280px;
                background-size: 100% 100%;
                background-repeat: no-repeat;
            }

            h1 {
                font-family: PingFangSC-Medium,PingFang SC;
                font-weight: 500;
                font-size: 42px;
                margin-top: 50px;
                line-height: 59px;
                text-align: center;
                color:rgba(51,51,51,1);
            }

            h2 {
                font-family: 'PingFangSC-Regular';
                font-weight: 400;
                font-size: 28px;
                line-height: 36px;
                margin: 0 50px;
                margin-top: 20px;
            }
        }

        .servicePhone {
            position: absolute;
            display: flex;
            justify-content:space-between;
            align-items: center;
            top: 128px;
            right:0;
            width: 200px;
            height: 60px;
            background: #FAFAFA;
            border-radius: 40px;
            border: 1px solid #EEEEEE;
            padding:0 23px 0 28px;
            img{
            width: 29px;
            height:29px;
            span{
                width: 104px;
                height: 37px;
                font-size: 26px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 37px;
            }
            }
        }

        .activity-container {
            display: flex;
            align-items: center;
            width: 672px;
            margin: 0 auto;
            height: 140px;
            padding-left: 30px;
            padding-right: 30px;
            margin-top: 70px;
            margin-bottom: 60px;
            border-radius: 20px;
            background: linear-gradient(
                90deg,
                rgba(255,179,92,1) 0%,
                rgba(253,122,22,1) 100%
            );
            .logo {
                width: 80px;
                height: 80px;
                margin-right: 20px;
            }
            .text {
                flex: 1;
                > h1 {
                    font-size: 30px;
                    color: #FFFFFF;
                    line-height: 42px;
                }
                > p {
                    font-size: 24px;
                    color: #FFFFFF;
                    line-height: 33px;
                }
            }
            .button {
                width: 160px;
                height: 60px;
                line-height: 60px;
                background: transparent;
                font-size: 28px;
                border-radius: 10px;
                border:1px solid rgba(255,255,255,1);
            }
        }
    }
</style>

<style lang="less">
@import "../../assets/less/mixin.less";

    .withdraw-result {
        .van-pull-refresh__track {
            display: flex;
            flex-direction: column;
            width: 100%;
        }
        .van-pull-refresh__loading {
            color: #fff;
            .van-loading {
                color: #fff!important;
            }
        }
    }
</style>
